export type AppNameEnum =
    'Einspruch'
    | 'ELA'
    | 'Nachreichung'
    | 'Sonstige'
    | 'COVID'
    | 'Fragebogen_BetPG'
    | 'Fragebogen_EUn'
    | 'Fragebogen_KapG'
    | 'Fragebogen_PersG'
    | 'Fragebogen_KapGAus';

export const AppNameEnum = {
    Einspruch: 'Einspruch' as AppNameEnum,
    ELA: 'ELA' as AppNameEnum,
    Nachreichung: 'Nachreichung' as AppNameEnum,
    Sonstige: 'Sonstige' as AppNameEnum,
    COVID: 'COVID' as AppNameEnum,
    FragebogenBetPG: 'Fragebogen_BetPG' as AppNameEnum,
    FragebogenEUn: 'Fragebogen_EUn' as AppNameEnum,
    FragebogenKapG: 'Fragebogen_KapG' as AppNameEnum,
    FragebogenPersG: 'Fragebogen_PersG' as AppNameEnum,
    FragebogenKapGAus: 'Fragebogen_KapGAus' as AppNameEnum
};

